import type {AgentSubType} from 'types';
import type {Agent, AgentName} from 'services/agent/types';

export const createEmptyAgent = (
  agentType: AgentSubType,
  suggestion?: string,
): Agent => {
  const suggestedNameVariant: AgentName[] | undefined = suggestion
    ? [{name: suggestion}]
    : undefined;

  return {agentType, nameVariants: suggestedNameVariant} as Agent;
};
